import { cn } from "@/lib/utils";

// Radio indicator for selectable cards — visual only, the card itself is the
// button. `included` = covered by a selected ancestor (muted dot).
export default function RadioCircle({ active, included = false }: { active: boolean; included?: boolean }) {
  return (
    <span
      aria-hidden
      className={cn(
        "flex size-4 shrink-0 items-center justify-center rounded-full border bg-background",
        active ? "border-primary" : included ? "border-primary/40" : "border-input"
      )}
    >
      {active && <span className="size-2 rounded-full bg-primary" />}
      {!active && included && <span className="size-2 rounded-full bg-primary/40" />}
    </span>
  );
}
